export const AddressHelpers = () => {

    const FindPaeseInCollectionFromId = (basePaeseList, id) => {
        return basePaeseList.filter((item) => item.id === id)[0]
    }
    const FindProvinciaInCollectionFromId = (baseProvinciaList, id) => {
        return baseProvinciaList.filter((item) => item.id === id)[0]
    }
    const IsPaeseIta = (paese) => {
        return paese !== undefined && paese.identificativo === "ITA"
    }

    return {
        FindPaeseInCollectionFromId,
        FindProvinciaInCollectionFromId,
        IsPaeseIta,
    }
}